<!-- Buttons top right — same buttons, icons and position as the company profile (add-edit-company2.page). -->
<!-- "+ Neue Person": header row in the flow, like "+ Neue Firma" — a floating button would sit on
     top of the first card. The profile keeps the floating bar, like the company profile. -->
<div class="person-form-header" *ngIf="isNew">
    <span>{{ local.aumico_persons_form_details_text | i18next }}</span>
    <div class="person-form-header__buttons">
        <ham-button
            icon="assets/hamIcons/floppy-outline.svg"
            type="button"
            size="lg"
            [disabled]="!canSave"
            (buttonClick)="onSave()"
        >
            {{ local.aumico_persons_form_save | i18next }}
        </ham-button>
    </div>
</div>

<!-- Inactive person: same banner and text as the inactive company profile. -->
<div class="inactive-banner" *ngIf="!isNew && !active">
    <span class="ham-icon">
        <i class="exclamation-outline-icon"></i>
    </span>
    <div class="inactive-banner__text" data-testid="person-inactive-hint">{{ 'aumico_companies_inactivate_banner_text' | i18next }}</div>
</div>

<div class="person-form-actions" *ngIf="!isNew">
    <ng-container *ngIf="!isNew">
        <ham-button
            icon="assets/hamIcons/trash-outline.svg"
            type="button"
            size="lg"
            [outline]="true"
            data-testid="person-delete"
            (buttonClick)="showDeleteDialog = true"
        >
            {{ local.aumico_persons_form_delete | i18next }}
        </ham-button>
        <ham-button
            *ngIf="active"
            icon="assets/hamIcons/moon-outline.svg"
            type="button"
            size="lg"
            variant="red"
            [outline]="true"
            data-testid="person-deactivate"
            (buttonClick)="statusChange.emit(false)"
        >
            {{ local.aumico_persons_form_deactivate | i18next }}
        </ham-button>
        <ham-button
            *ngIf="!active"
            icon="assets/hamIcons/check-circle-outline.svg"
            type="button"
            size="lg"
            variant="green"
            [outline]="true"
            data-testid="person-activate"
            (buttonClick)="activate()"
        >
            {{ local.aumico_persons_form_activate | i18next }}
        </ham-button>
    </ng-container>
    <ham-button
        icon="assets/hamIcons/floppy-outline.svg"
        type="button"
        size="lg"
        [disabled]="!canSave"
        data-testid="person-save"
        (buttonClick)="onSave()"
    >
        {{ local.aumico_persons_form_save | i18next }}
    </ham-button>
</div>

<!-- Cards: markup + styles of the company form (`form-card`, two columns). -->
<form class="page-wrapper" [formGroup]="form">
    <!-- ── Left Column ────────────────────────────────────────────────────── -->
    <div class="page-col page-col--main">
        <!-- Card: Personalien -->
        <div class="form-card">
            <div class="form-card-header">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                </svg>
                <span class="form-card-title">{{ local.aumico_persons_form_section_personal | i18next }}</span>
            </div>
            <div class="form-card-body">
                <div class="aum-row">
                    <div class="aum-col">
                        <label class="field-label">
                            {{ local.aumico_persons_form_first_name | i18next }}
                            <span class="required-star">*</span>
                        </label>
                        <input
                            hamInput
                            formControlName="firstName"
                            placeholder="{{ local.aumico_persons_form_placeholder | i18next }}"
                            showRequired="true"
                        />
                    </div>
                    <div class="aum-col">
                        <label class="field-label">
                            {{ local.aumico_persons_form_last_name | i18next }}
                            <span class="required-star">*</span>
                        </label>
                        <input
                            hamInput
                            formControlName="lastName"
                            data-testid="person-last-name"
                            placeholder="{{ local.aumico_persons_form_placeholder | i18next }}"
                            showRequired="true"
                        />
                    </div>
                </div>

                <!-- Mandatsleiter + Sachbearbeiter: search + "Zuständig seit" card, like the company form. -->
                <div class="aum-row">
                    <div class="aum-col usersearch">
                        <input
                            hamSearchDropDown
                            [options]="users"
                            [optionKeys]="['name']"
                            returnKey="id"
                            [label]="local.aumico_persons_form_assignee | i18next"
                            [returnObject]="true"
                            [placeholder]="local.aumico_persons_form_search | i18next"
                            [formControl]="form.controls.assignee"
                            [multiple]="false"
                            [hideDisplaySelection]="true"
                            showRequired="true"
                        />
                        <div class="meta-card" *ngIf="form.controls.assignee.value">
                            <company-editor-meta-info
                                [meta]="{
                                    createdByName: form.controls.assignee.value?.name || userName(form.controls.assignee.value?.id),
                                    createdAt: form.controls.assignedOn.value
                                }"
                                (close)="form.controls.assignee.setValue(null)"
                            ></company-editor-meta-info>
                        </div>
                    </div>
                    <div class="aum-col usersearch">
                        <input
                            hamSearchDropDown
                            [options]="users"
                            [optionKeys]="['name']"
                            returnKey="id"
                            [label]="local.aumico_persons_form_clerk | i18next"
                            [returnObject]="true"
                            [placeholder]="local.aumico_persons_form_search | i18next"
                            [formControl]="form.controls.clerk"
                            data-testid="person-clerk"
                            [multiple]="false"
                            [hideDisplaySelection]="true"
                            showRequired="true"
                        />
                        <div class="meta-card" *ngIf="form.controls.clerk.value">
                            <company-editor-meta-info
                                [meta]="{
                                    createdByName: form.controls.clerk.value?.name || userName(form.controls.clerk.value?.id),
                                    createdAt: form.controls.assignedOnClerk.value
                                }"
                                (close)="form.controls.clerk.setValue(null)"
                            ></company-editor-meta-info>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Card: Adresse — same fields as the company address, without country. -->
        <div class="form-card">
            <div class="form-card-header">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                </svg>
                <span class="form-card-title">{{ local.aumico_persons_form_section_address | i18next }}</span>
            </div>
            <div class="form-card-body">
                <div class="aum-row">
                    <div class="aum-col">
                        <label class="field-label">{{ local.aumico_persons_form_street | i18next }}</label>
                        <input hamInput formControlName="street" data-testid="person-street" placeholder="{{ local.aumico_persons_form_placeholder | i18next }}" />
                    </div>
                    <div class="aum-col">
                        <label class="field-label">{{ local.aumico_persons_form_addition_to_address | i18next }}</label>
                        <input
                            hamInput
                            formControlName="additionToAddress"
                            data-testid="person-addition"
                            placeholder="{{ local.aumico_persons_form_placeholder | i18next }}"
                        />
                    </div>
                </div>
                <div class="aum-row">
                    <div class="aum-col">
                        <label class="field-label">{{ local.aumico_persons_form_zip | i18next }}</label>
                        <input hamInput formControlName="zip" data-testid="person-zip" placeholder="{{ local.aumico_persons_form_placeholder | i18next }}" />
                    </div>
                    <div class="aum-col">
                        <label class="field-label">{{ local.aumico_persons_form_city | i18next }}</label>
                        <input hamInput formControlName="city" data-testid="person-city" placeholder="{{ local.aumico_persons_form_placeholder | i18next }}" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ── Right Column ────────────────────────────────────────────────────── -->
    <div class="page-col page-col--side">
        <!-- Card: Kontaktdaten — one field per contact; "+ Kontakt hinzufügen" adds one of the chosen type. -->
        <div class="form-card">
            <div class="form-card-header">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                </svg>
                <span class="form-card-title">{{ local.aumico_persons_form_section_contact | i18next }}</span>
            </div>
            <div class="form-card-body">
                <div class="contacts-grid" formArrayName="contacts">
                    <div class="aum-col" *ngFor="let contact of contacts.controls; let i = index" [formGroupName]="i">
                        <label class="field-label">{{
                            (contact.controls.type.value === contactType.EMAIL
                                ? local.aumico_persons_form_email
                                : local.aumico_persons_form_phone
                            ) | i18next
                        }}</label>
                        <div class="contact-field">
                            <input
                                hamInput
                                formControlName="value"
                                data-testid="person-contact"
                                [attr.data-contact-type]="contact.controls.type.value"
                                [placeholder]="
                                    (contact.controls.type.value === contactType.EMAIL
                                        ? local.aumico_persons_form_email
                                        : local.aumico_persons_form_phone
                                    ) | i18next
                                "
                            />
                            <!-- The first e-mail and the first phone field stay; every further one can be removed. -->
                            <button
                                *ngIf="isRemovableContact(i)"
                                type="button"
                                class="contact-field__remove"
                                [attr.aria-label]="local.aumico_persons_form_remove_contact_aria | i18next"
                                (click)="removeContact(i)"
                            >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                    <line x1="18" y1="6" x2="6" y2="18" />
                                    <line x1="6" y1="6" x2="18" y2="18" />
                                </svg>
                            </button>
                        </div>
                        <div class="warning" *ngIf="contact.errors?.['email']">
                            {{ local.aumico_persons_form_email_invalid | i18next }}
                        </div>
                    </div>
                </div>
                <!-- Menu styled like "+ Neue Spalte" of the equity movement schedule (there page-internal). -->
                <div>
                    <ham-button
                        variant="teal"
                        [outline]="true"
                        lucideIcon="plus"
                        type="button"
                        [matMenuTriggerFor]="addContactMenu"
                    >
                        {{ local.aumico_persons_form_add_contact | i18next }}
                    </ham-button>
                    <mat-menu #addContactMenu="matMenu" class="contact-type-menu">
                        <button mat-menu-item class="contact-type-option" type="button" (click)="addContact(contactType.EMAIL)">
                            {{ local.aumico_persons_form_email | i18next }}
                        </button>
                        <button mat-menu-item class="contact-type-option" type="button" (click)="addContact(contactType.PHONE)">
                            {{ local.aumico_persons_form_phone | i18next }}
                        </button>
                    </mat-menu>
                </div>
            </div>
        </div>

        <!-- Card: Verknüpfte Firmen — saved only with "Speichern". -->
        <div class="form-card">
            <div class="form-card-header">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                </svg>
                <span class="form-card-title">{{ local.aumico_persons_form_section_companies | i18next }}</span>
            </div>
            <div class="form-card-body">
                <div class="company-links" *ngIf="links.length > 0">
                    <div
                        class="company-link"
                        data-testid="person-company-link"
                        [attr.data-company-deleted]="link.companyDeleted ? 'true' : 'false'"
                        *ngFor="let link of links; let i = index"
                        [class.company-link--deleted]="link.companyDeleted"
                        [hamTooltip]="link.companyDeleted ? (local.aumico_persons_form_company_deleted | i18next) : null"
                        [class.company-link--clickable]="!link.companyDeleted"
                        (click)="!link.companyDeleted && companyClick.emit(link.companyId)"
                    >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                        </svg>
                        <span class="company-link__name">{{ link.companyName }}</span>
                        <span class="company-link__role">{{ roleLabel(link.role) }}</span>
                        <button
                            type="button"
                            class="company-link__remove"
                            [attr.aria-label]="local.aumico_persons_form_unlink_aria | i18next"
                            (click)="$event.stopPropagation(); unlink(i)"
                        >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="aum-row">
                    <div class="aum-col">
                        <input
                            hamSimpleDropDown
                            [options]="companyOptions"
                            [optionKeys]="['name']"
                            returnKey="id"
                            [returnObject]="true"
                            [label]="local.aumico_persons_form_company | i18next"
                            [placeholder]="local.aumico_persons_form_please_choose | i18next"
                            [formControl]="linkCompany"
                        />
                    </div>
                    <div class="aum-col aum-col--narrow">
                        <input
                            hamSimpleDropDown
                            [options]="roleOptions"
                            [optionKeys]="['name']"
                            returnKey="id"
                            [returnObject]="true"
                            [allowFreeText]="false"
                            [label]="local.aumico_persons_form_role | i18next"
                            [placeholder]="local.aumico_persons_form_please_choose | i18next"
                            [formControl]="linkRole"
                        />
                    </div>
                </div>
                <div>
                    <ham-button
                        variant="teal"
                        [outline]="true"
                        lucideIcon="plus"
                        type="button"
                        [disabled]="!canLink"
                        (buttonClick)="link()"
                    >
                        {{ local.aumico_persons_form_link | i18next }}
                    </ham-button>
                </div>
            </div>
        </div>

        <!-- Card: Tag -->
        <div class="form-card">
            <div class="form-card-header">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                    <line x1="7" y1="7" x2="7.01" y2="7" />
                </svg>
                <span class="form-card-title">{{ local.aumico_tags_box_title | i18next }}</span>
            </div>
            <div class="form-card-body">
                <aumico-tag-box
                    [tags]="tags"
                    [selectedTagIds]="selectedTagIds"
                    [usage]="tagUsage"
                    [error]="tagError"
                    (selectionChange)="onTagSelectionChange($event)"
                    (create)="tagCreate.emit($event)"
                    (deleteRequest)="tagDeleteRequest.emit($event)"
                    (deleteConfirm)="tagDeleteConfirm.emit($event)"
                    (deleteCancel)="tagDeleteCancel.emit()"
                ></aumico-tag-box>
            </div>
        </div>
    </div>
</form>

<!-- Confirmation dialogs — same modal as the company profile, with person texts. -->
<ham-modal
    data-testid="tasks-update-dialog"
    *ngIf="showClerkDialog"
    [saveText]="'aumico_company_assignee_change_confirmation_dialog_save_button' | i18next"
    [size]="'default'"
    [showCancelButton]="true"
    [cancelText]="'aumico_licence_banner_dialog_close_button' | i18next"
    (cancel)="cancelClerkChange()"
    (save)="confirmClerkChange()"
>
    <div class="task-reassignment">
        <h3>{{ 'aumico_company_assignee_change_confirmation_dialog_title' | i18next }}</h3>
        <span class="description">{{ local.aumico_persons_form_clerk_change_dialog_text | i18next }}</span>
        <label class="option-card" data-testid="tasks-update-current" (click)="selectedTaskUpdate = tasksUpdateOption.UPDATE_TASKS_ASSIGNED_TO_CURRENT">
            <div class="content">
                <div class="title">
                    {{ 'aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user' | i18next }}
                </div>
                <div class="description">
                    {{
                        'aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user_description_text'
                            | i18next
                    }}
                </div>
            </div>
            <input
                type="radio"
                name="task-reassignment"
                [checked]="selectedTaskUpdate === tasksUpdateOption.UPDATE_TASKS_ASSIGNED_TO_CURRENT"
            />
        </label>
        <label class="option-card" data-testid="tasks-update-all" (click)="selectedTaskUpdate = tasksUpdateOption.UPDATE_ALL_TASKS">
            <div class="content">
                <div class="title">{{ 'aumico_company_assignee_change_confirmation_update_all_tasks' | i18next }}</div>
                <div class="description">
                    {{ 'aumico_company_assignee_change_confirmation_update_all_tasks_description_text' | i18next }}
                </div>
            </div>
            <input type="radio" name="task-reassignment" [checked]="selectedTaskUpdate === tasksUpdateOption.UPDATE_ALL_TASKS" />
        </label>
    </div>
</ham-modal>

<ham-confirm-decline-modal
    class="confirm-decline-modal"
    *ngIf="showDeleteDialog"
    (cancel)="confirmDelete(false)"
    (action)="confirmDelete(true)"
    footerAlignment="center"
    actionBtnText="{{ local.aumico_persons_form_delete | i18next }}"
    noActionBtnText="{{ local.aumico_persons_form_dialog_cancel | i18next }}"
>
    <div class="modal-content">
        <div>
            <p class="title">{{ local.aumico_persons_form_delete_dialog_title | i18next }}</p>
            <p class="light">{{ local.aumico_persons_form_delete_dialog_text | i18next }}</p>
        </div>
    </div>
</ham-confirm-decline-modal>
